// components/ui/toaster.tsx
"use client";

import { useToast } from "@/hooks/use-toast";
import { Toast, ToastViewport } from "@/components/ui/toast";
import { useIsMobile } from "@/hooks/use-mobile";
import { cn } from "@/lib/utils";
import { createPortal } from "react-dom";
import { Fragment } from "react";

interface ToasterProps {
  className?: string;
}

export function Toaster({ className }: ToasterProps) {
  const { toasts, dismiss } = useToast();
  const isMobile = useIsMobile();

  if (isMobile) {
    return (
      <>
        {toasts.map((toast) => (
          <Fragment key={toast.id}>
            {createPortal(
              <div
                style={{ position: "fixed", top: 0, left: 0, right: 0 }}
                className='flex justify-center z-[999] pointer-events-none'
              >
                <div className='w-full px-2 pointer-events-auto'>
                  <Toast
                    variant={toast.variant}
                    title={toast.title}
                    description={toast.description}
                    icon={toast.icon}
                    duration={toast.duration}
                    onClose={() => dismiss(toast.id)}
                    className='w-full'
                  />
                </div>
              </div>,
              document.body
            )}
          </Fragment>
        ))}
      </>
    );
  }

  // For desktop, render all toasts in a viewport
  return (
    <ToastViewport
      className={cn("fixed top-0 flex flex-col gap-2 z-[100]", className)}
    >
      {toasts.map((toast) => (
        <Toast
          key={toast.id}
          variant={toast.variant}
          title={toast.title}
          description={toast.description}
          icon={toast.icon}
          duration={toast.duration}
          onClose={() => dismiss(toast.id)}
        />
      ))}
    </ToastViewport>
  );
}
